import http from "./httpService";
import auth from "./authService";

const headers = {
  headers: {
    "Content-Type": "multipart/form-data"
  }
};

function supplierStoreUrl(id) {
  if (id) return `/v1/invoices/${id}`;
  else return `/v1/invoices`;
}

export function getAll() {
  return http.get(supplierStoreUrl());
}

export function deleteSingle(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveSingle(supplier) {
  return http.post(supplierStoreUrl(), supplier,headers);
}

export function updateSingle(supplier, invoiceId) {
  return http.post(supplierStoreUrl(invoiceId), supplier,headers);
}

export function updateSingleStatus(supplier) {
  return http.get(`/v1/invoices/${supplier.id}/status`);
}

export function getSingle(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}
